// A/B test "In-image scroll" on collection product cards - see snippets/ab-image-scroll.liquid.
// Drives the gallery arrows and dots, and pushes the scroll-depth events to Intelligems.
(function () {
  const sent = {};

  // The variant is CSS-only, so there is no class to check: the gallery being a flex scroller is what
  // tells the variant apart. In the control it is `display: contents` and can never scroll anyway.
  function isActive(gallery) {
    return getComputedStyle(gallery).display === 'flex';
  }

  function trackEvent(name) {
    if (sent[name]) return;
    sent[name] = true;
    window.igEvents = window.igEvents || [];
    window.igEvents.push({ event: name });
  }

  function slides(gallery) {
    return gallery.children.length;
  }

  function currentIndex(gallery) {
    const width = gallery.clientWidth;
    if (!width) return 0;
    // Math.abs: scrollLeft is negative in RTL.
    return Math.min(slides(gallery) - 1, Math.round(Math.abs(gallery.scrollLeft) / width));
  }

  function controlsFor(gallery) {
    const figure = gallery.closest('.product-card__figure');
    return figure && figure.querySelector('[data-image-scroll-controls]');
  }

  function update(gallery) {
    const index = currentIndex(gallery);
    const controls = controlsFor(gallery);

    if (controls) {
      controls.querySelectorAll('.product-card__gallery-dot').forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
      // No "prev" on the first image, no "next" on the last.
      controls.classList.toggle('is-at-start', index === 0);
      controls.classList.toggle('is-at-end', index === slides(gallery) - 1);
    }

    if (!isActive(gallery)) return;

    if (index < 1) return;

    // Percent of the gallery reached. With at most 3 images the only steps are 0, 50 and 100%, so these
    // are the only two thresholds; reaching the end also sends 50.
    const progress = (index / (slides(gallery) - 1)) * 100;

    [50, 100].forEach(function (threshold) {
      if (progress >= threshold) trackEvent('image_scroll_' + threshold);
    });
  }

  // Scroll events do not bubble, but they do reach a capturing listener on document.
  const pending = new WeakSet();
  document.addEventListener('scroll', function (event) {
    const target = event.target;
    if (!(target instanceof Element) || !target.hasAttribute('data-image-scroll-track')) return;
    if (pending.has(target)) return;
    pending.add(target);
    requestAnimationFrame(function () {
      pending.delete(target);
      update(target);
    });
  }, { capture: true, passive: true });

  // Arrows stop at the ends (the arrow pointing past the end is hidden by update()).
  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-image-scroll-step]');
    if (!button) return;
    event.preventDefault();

    const figure = button.closest('.product-card__figure');
    const gallery = figure && figure.querySelector('[data-image-scroll-track]');
    if (!gallery || !isActive(gallery)) return;

    const count = slides(gallery);
    const next = Math.max(0, Math.min(count - 1, currentIndex(gallery) + Number(button.getAttribute('data-image-scroll-step'))));
    const direction = getComputedStyle(gallery).direction === 'rtl' ? -1 : 1;

    trackEvent('image_scroll_arrow_click');
    gallery.scrollTo({ left: next * gallery.clientWidth * direction, behavior: 'smooth' });
  });

  // Variant C, mouse: the gallery is dragged. The variant C CSS gives the gallery `cursor: grab` (through
  // --image-scroll-cursor), and that computed cursor is the only switch here: B and the control keep the
  // link's pointer, so none of this runs for them. Touch and trackpads scroll natively already.
  // scroll-snap is suspended while the button is down (`is-dragging`) so the images follow the mouse;
  // on release the gallery scrolls smoothly to the nearest image and snap comes back once it has settled.
  let drag = null;

  // Expects `is-settling` to be on already: it has to go on before `is-dragging` comes off, or the style
  // recalc in between re-enables snap and Chrome jumps to the nearest image instead of gliding there.
  function settle(gallery) {
    const direction = getComputedStyle(gallery).direction === 'rtl' ? -1 : 1;
    const target = currentIndex(gallery) * gallery.clientWidth * direction;
    let done = false;
    const finish = function () {
      if (done) return;
      done = true;
      gallery.removeEventListener('scrollend', finish);
      gallery.classList.remove('is-settling');
    };
    if (Math.abs(gallery.scrollLeft - target) < 1) {
      finish();
      return;
    }
    gallery.addEventListener('scrollend', finish);
    setTimeout(finish, 600); // browsers without scrollend
    gallery.scrollTo({ left: target, behavior: 'smooth' });
  }

  document.addEventListener('pointerdown', function (event) {
    if (event.pointerType !== 'mouse' || event.button !== 0) return;
    const gallery = event.target.closest('[data-image-scroll-track]');
    if (!gallery || !isActive(gallery) || getComputedStyle(gallery).cursor !== 'grab') return;
    drag = { gallery: gallery, pointerId: event.pointerId, startX: event.clientX, startLeft: gallery.scrollLeft, moved: false };
    gallery.classList.remove('is-settling');
    gallery.classList.add('is-dragging');
    try { gallery.setPointerCapture(event.pointerId); } catch (e) { /* synthetic pointer */ }
    event.preventDefault(); // no text selection, no image ghost
  });

  document.addEventListener('pointermove', function (event) {
    if (!drag || event.pointerId !== drag.pointerId) return;
    const dx = event.clientX - drag.startX;
    if (Math.abs(dx) > 3) drag.moved = true;
    drag.gallery.scrollLeft = drag.startLeft - dx;
  });

  function swallowClick(event) {
    event.preventDefault();
    event.stopPropagation();
  }

  function endDrag(event) {
    if (!drag || event.pointerId !== drag.pointerId) return;
    const gallery = drag.gallery;
    const moved = drag.moved;
    drag = null;
    gallery.classList.add('is-settling');
    gallery.classList.remove('is-dragging');
    settle(gallery);
    if (moved) {
      // The product link around the gallery would open on this mouseup's click; swallow that one click.
      // The click, if any, is dispatched right after pointerup, so the guard is lifted straight after.
      document.addEventListener('click', swallowClick, true);
      setTimeout(function () { document.removeEventListener('click', swallowClick, true); }, 50);
    }
  }

  document.addEventListener('pointerup', endDrag);
  document.addEventListener('pointercancel', endDrag);
})();
